<ng-container *ngIf="topHeader">
    <!-- <ng-template applyTopHeaderContent> -->
        <ubs-top-header class="top-header" [topHeaderConfig]="topHeaderConfig"></ubs-top-header>
    <!-- </ng-template> -->
</ng-container>
<ng-container *ngIf="mainHeader">
    <!-- <ng-template applyTopHeaderContent> -->
        <ubs-main-header [mainHeaderConfig]="mainHeaderConfig" [mainMenuConfig]="mainMenuConfig" [menuItems]="menuItems" class="main-header"></ubs-main-header>
    <!-- </ng-template> -->
</ng-container>
<ng-container *ngIf="bottomHeader">
    <!-- <ng-template applyTopHeaderContent> -->
        <ubs-bottom-header [menuItems]="menuItems" class="bottom-header"></ubs-bottom-header>
    <!-- </ng-template> -->
</ng-container>
